export * from './tunnel.service';

import { InjectionToken } from '@angular/core';

export const SHOW_THREEJS_STATS = new InjectionToken<boolean>(
  'SHOW_THREEJS_STATS'
);
